<div class="top-bar-content">
  <div class="title-subtitle">
    <h1>{{ title ?? '--' }}</h1>
    <small>{{ description }}</small>
  </div>
</div>
